'use client';

import Image from 'next/image';
import { Trophy } from 'lucide-react';
import { useTranslations } from 'next-intl';

export function LeaderboardHero() {
  const t = useTranslations('leaderboard');

  return (
    <section className="relative h-[280px] md:h-[360px]">
      <Image
        src="/images/dgr/HeroImage.jpg"
        alt="Leaderboard"
        fill
        className="object-cover"
        priority
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <h1 className="text-4xl md:text-5xl font-bold text-white">{t('title')}</h1>
          </div>
          <p className="text-white/80 text-lg max-w-xl mx-auto px-4">{t('subtitle')}</p>
        </div>
      </div>
    </section>
  );
}
